// React
import React from 'react';

import ReactExport from 'react-data-export';

// UI
import {Button} from '@material-ui/core';
import RonadIcons from '../../../components/iconComponent';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
type Props = {
  getData: any;
  data: any;
  filtersValues: any;
  loading: boolean;
};

function EXCEL(props: Props) {
    const handleCreateExcel = () => {
      props.getData({
        ...props.filtersValues,
        size: 10000,
        'partnerId.equals': props.id,
      });
    };
  const flattData = (data: any) => {
    const newData = data.map((item: any) => {
      return {
        name: item.name,
        code: item.code,
        categoryName: item.categoryName ?? 'نا مشخص',
        sumCount: item.sumCount,
      };
    });
    return newData;
  };

  return (
    <>
      {props.data.length > 0 ? (
        <ExcelFile
        element={
          <Button
            style={{marginLeft: '8px'}}
            size="large"
            variant="outlined"
            color="primary"
            startIcon={<RonadIcons name='download' size={.7} className='text-primary' style={{marginTop: "-4px"}}/>}
            onClick={handleCreateExcel}
            disabled={props.loading}
          >
            EXCEL
          </Button>
        }
      >
        <ExcelSheet data={flattData(props.data)} name="orders">
          {props.data &&
            Object.entries(flattData(props.data)[0])?.map(el => {
              return <ExcelColumn label={el[0]} value={el[0]} />;
            })}
        </ExcelSheet>
      </ExcelFile>
      ) : (
        <Button
          style={{marginLeft: '8px'}}
          size="large"
          variant="outlined"
          color="primary"
          startIcon={<RonadIcons name='plus' size={.6} className='text-primary' style={{marginTop: "-4px"}}/>}
          onClick={handleCreateExcel}
          disabled={props.loading}
        >
          EXCEL
        </Button>
      )}
    </>
  );
}

export default EXCEL;
